// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_PRODUCT_COMPLAINT_TITLE = "Nahlasujem inzer\u00e1t, ktor\u00fd poru\u0161uje pravidl\u00e1 - https://www.modrykonik.sk/ine/pravidla-bazara/";
export const FORUM_COMMENT_DOES_NOT_BELONG_TO_FORUM = "Nahlasujem nevhodn\u00fa odpove\u010f";
export const IMAGE_DOES_NOT_BELONG_TO_PHOTOBLOG = "Nahl\u00e1si\u0165 obr\u00e1zok";
export const MESSAGE_DOES_NOT_BELONG_TO_FORUM = "Nahlasujem nevhodn\u00fd pr\u00edspevok";
export const PHOTOBLOG_COMMENT_DOES_NOT_BELONG_TO_PHOTOBLOG = "Nahlasujem nevhodn\u00fd koment\u00e1r";
export const PHOTOBLOG_POST_DOES_NOT_BELONG_TO_PHOTOBLOG = "Nahlasujem nevhodn\u00fd pr\u00edspevok";
